import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../types/api-response.type';
import { DocumentMedia } from '../../types/document.type';
import { ApiService } from '../api/api.service';
import { DocumentationTerms } from '../../enum/documentation-terms.enum';
import { DocumentationSlugs } from '../../enum/documentation-slugs.enum';

@Injectable({
  providedIn: 'root',
})
export class DocumentService extends ApiService<DocumentMedia> {
  constructor() {
    super();
    this.moduleUrl.set('/jsonapi/media/document');
  }

  /**
   * Obtiene documentos filtrados por término de sección
   * @param term Término de documentación para filtrar
   * @param includeFile Si se debe incluir el archivo relacionado field_media_document
   * @returns Observable con la respuesta de la API
   */
  getDocumentsByTerm(
    term: DocumentationTerms,
    includeFile: boolean = true,
  ): Observable<ApiResponse<DocumentMedia[]>> {
    const headers = {
      Accept: 'application/vnd.api+json',
    };

    const params: any = {
      'filter[field_sections.name]': term,
    };

    if (includeFile) {
      params['include'] = 'field_media_document';
    }

    return this.http.get<ApiResponse<DocumentMedia[]>>(this.url(), {
      headers,
      params,
    });
  }

  /**
   * Obtiene un documento específico por su slug
   * @param slug Slug del documento
   * @param includeFile Si se debe incluir el archivo relacionado field_media_document
   * @returns Observable con la respuesta de la API
   */
  getDocumentBySlug(
    slug: DocumentationSlugs,
    includeFile: boolean = true,
  ): Observable<ApiResponse<DocumentMedia[]>> {
    const headers = {
      Accept: 'application/vnd.api+json',
    };

    const params: any = {
      'filter[field_slug]': slug,
    };

    if (includeFile) {
      params['include'] = 'field_media_document';
    }

    return this.http.get<ApiResponse<DocumentMedia[]>>(this.url(), {
      headers,
      params,
    });
  }
}
